import {Buffer} from 'buffer';
import Ajv, {JTDSchemaType} from 'ajv/dist/jtd';

export function JSONParse<T>(json: string, schema: JTDSchemaType<T>): T | undefined {
  const ajv = new Ajv();
  const parse = ajv.compileParser<T>(schema);
  return parse(json);
}
export  function parseJwt (token:any) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

export function decodeJwt<T>(token: string, schema: JTDSchemaType<T>): any{
  try {

    if (token) {
      return parseJwt(token);
    }
    

  } catch (error) {
    return Promise.reject(error);
  }
}
